/*
 * This file is part of ng2-json-editor.
 * Copyright (C) 2017 CERN.
 *
 * ng2-json-editor is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License as
 * published by the Free Software Foundation; either version 2 of the
 * License, or (at your option) any later version.
 *
 * ng2-json-editor is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with ng2-json-editor; if not, write to the Free Software Foundation, Inc.,
 * 59 Temple Place, Suite 330, Boston, MA 02111-1307, USA.
 * In applying this license, CERN does not
 * waive the privileges and immunities granted to it by virtue of its status
 * as an Intergovernmental Organization or submit itself to any jurisdiction.
*/

import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';

import { IDiffResult } from 'diff';

import { TextDiffService } from '../shared/services';


export class TextDiffComponent {

   newText: string;
   currentText: string;

  constructor(public textDiffService: TextDiffService) { }

  get diffs(): Array<IDiffResult> {
    return this.textDiffService
      .diffByWord(this.currentText, this.newText);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'text-diff',
  template: "<span *ngFor=\"let diff of diffs\" [ngClass]=\"{added: diff.added, removed: diff.removed}\">{{diff.value}}</span>",
  styles: [".added { color: green; font-weight: bold; } .removed { color: red; text-decoration: line-through; } "],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TextDiffService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'newText': [{ type: Input },],
'currentText': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
